var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToilet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2699_627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.04166 19.25V13.2916H4.58332C4.07916 13.2916 3.66666 12.8791 3.66666 12.375V8.24998C3.66666 7.24165 4.49166 6.41665 5.49999 6.41665H8.24999C9.25832 6.41665 10.0833 7.24165 10.0833 8.24998V12.375C10.0833 12.8791 9.67082 13.2916 9.16666 13.2916H8.70832V19.25C8.70832 19.7541 8.29582 20.1666 7.79166 20.1666H5.95832C5.45416 20.1666 5.04166 19.7541 5.04166 19.25ZM16.5 19.25V14.6666H17.9758C18.5992 14.6666 19.0392 14.0525 18.8467 13.4566L16.9217 7.67248C16.665 6.92081 15.9683 6.41665 15.18 6.41665H15.07C14.2817 6.41665 13.5758 6.92081 13.3283 7.67248L11.4033 13.4566C11.2017 14.0525 11.6417 14.6666 12.2742 14.6666H13.75V19.25C13.75 19.7541 14.1625 20.1666 14.6667 20.1666H15.5833C16.0875 20.1666 16.5 19.7541 16.5 19.25ZM6.87499 5.49998C7.89249 5.49998 8.70832 4.68415 8.70832 3.66665C8.70832 2.64915 7.89249 1.83331 6.87499 1.83331C5.85749 1.83331 5.04166 2.64915 5.04166 3.66665C5.04166 4.68415 5.85749 5.49998 6.87499 5.49998ZM15.125 5.49998C16.1425 5.49998 16.9583 4.68415 16.9583 3.66665C16.9583 2.64915 16.1425 1.83331 15.125 1.83331C14.1075 1.83331 13.2917 2.64915 13.2917 3.66665C13.2917 4.68415 14.1075 5.49998 15.125 5.49998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2699_627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilet);
export default __webpack_public_path__ + "static/media/toilet.b2b38db7e178be57c3eb8e1884424d7b.svg";
export { ForwardRef as ReactComponent };